export default __webpack_public_path__ + "static/PromptIconTwo-b5228337d0bac1ba574c1e31d4caa40b.png";